import { Block, Spacer, Video } from "../../../../src/components/project/project";
import * as React from 'react';
export default {
  Block,
  Spacer,
  Video,
  React
};